import Fuse from 'fuse.js'

/**
 * Gives the options for our fuse search
 * @param {Array} data pannel of data on which you want to search
 * @param {String} query query to perform search on
 * @param {Array} keys Keys on which to search on
 * @returns {Array}
 */
export const filterByQuery = (data, query, keys) => {
    const options = {
        keys: keys,
        threshold: 0.0,
        distance: 10000,
        minMatchCharLength: 1,
        includeScore: true,
        includeMatches: true,
        findAllMatches: true
    }

    const fuse = new Fuse(data, options)
    return fuse.search(query.trim())
}
